<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div formGroupName="accountDetails">
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-md-8 control-label" for="federalTaxId">
          Federal Tax ID
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="federalTaxId"
            id="federalTaxId"
            [ngClass]="{
              'is-invalid':
                accountDetailsFormControls.federalTaxId.invalid &&
                (accountDetailsFormControls.federalTaxId.dirty ||
                  accountDetailsFormControls.federalTaxId.touched)
            }"
            formControlName="federalTaxId"
          />
          <div
            *ngIf="
              accountDetailsFormControls.federalTaxId.invalid &&
              (accountDetailsFormControls.federalTaxId.dirty ||
                accountDetailsFormControls.federalTaxId.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="accountDetailsFormControls.federalTaxId.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="accountDetailsFormControls.federalTaxId.errors?.pattern"
            >
              Please enter 9 numeric characters.
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
        <label class="col-md-8 control-label" for="accountUsage">
          Account Usage
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                name="accountUsage"
                id="accountUsage"
                formControlName="accountUsage"
                (change)="accountUsageChange($event)"
                [ngClass]="{
                  'is-invalid':
                    accountDetailsFormControls.accountUsage.invalid &&
                    (accountDetailsFormControls.accountUsage.dirty ||
                      accountDetailsFormControls.accountUsage.touched)
                }"
              >
                <option value="">--- Select Account Usage ---</option>
                <option
                  *ngFor="let ac of accountUsage | keyvalue"
                  [value]="ac.key"
                >
                  {{ ac.value }}
                </option>
              </select>
              <div
                *ngIf="
                  accountDetailsFormControls.accountUsage.invalid &&
                  (accountDetailsFormControls.accountUsage.dirty ||
                    accountDetailsFormControls.accountUsage.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="
                    accountDetailsFormControls.accountUsage.errors?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-md-8 control-label" for="accountType">
          Account Type
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                name="accountType"
                id="accountType"
                formControlName="accountType"
                (change)="resetDepositType($event)"
                [ngClass]="{
                  'is-invalid':
                    accountDetailsFormControls.accountType.invalid &&
                    (accountDetailsFormControls.accountType.dirty ||
                      accountDetailsFormControls.accountType.touched)
                }"
              >
                <option value="">--- Select Account Type ---</option>
                <option
                  *ngFor="let type of accountTypes | keyvalue"
                  [value]="type.key"
                >
                  {{ type.value }}
                </option>
              </select>
              <div
                *ngIf="
                  accountDetailsFormControls.accountType.invalid &&
                  (accountDetailsFormControls.accountType.dirty ||
                    accountDetailsFormControls.accountType.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="
                    accountDetailsFormControls.accountType.errors?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-group"
        *ngIf="
          accountDetailsFormControls.accountType.value === 'C' &&
          accountDetailsFormControls.accountUsage.value !== 'FeeWithdrawals'
        "
        [ngClass]="{
          fieldIsRequired:
            accountDetailsFormControls.accountType.value &&
            accountDetailsFormControls.accountType.value === 'C'
        }"
      >
        <label class="col-md-8 control-label" for="checkingDepositType">
          Checking Deposit Type
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                name="checkingDepositType"
                id="checkingDepositType"
                formControlName="checkingDepositType"
                [ngClass]="{
                  'is-invalid':
                    accountDetailsFormControls.checkingDepositType.invalid &&
                    (accountDetailsFormControls.checkingDepositType.dirty ||
                      accountDetailsFormControls.checkingDepositType.touched)
                }"
              >
                <option value="">--- Select Deposit Type ---</option>
                <option
                  *ngFor="let type of depositTypes | keyvalue"
                  [value]="type.key"
                >
                  {{ type.value }}
                </option>
              </select>
              <div
                *ngIf="
                  accountDetailsFormControls.checkingDepositType.invalid &&
                  (accountDetailsFormControls.checkingDepositType.dirty ||
                    accountDetailsFormControls.checkingDepositType.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="
                    accountDetailsFormControls.checkingDepositType.errors
                      ?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-md-8 control-label" for="routingNumber">
          Routing Number (ABA)
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="routingNumber"
            id="routingNumber"
            [ngClass]="{
              'is-invalid':
                accountDetailsFormControls.routingNumber?.invalid &&
                (accountDetailsFormControls.routingNumber?.dirty ||
                  accountDetailsFormControls.routingNumber?.touched)
            }"
            formControlName="routingNumber"
          />
          <div
            *ngIf="
              accountDetailsFormControls.routingNumber?.invalid &&
              (accountDetailsFormControls.routingNumber?.dirty ||
                accountDetailsFormControls.routingNumber?.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="accountDetailsFormControls.routingNumber?.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="accountDetailsFormControls.routingNumber?.errors?.pattern"
            >
              Please enter 9 numeric characters.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-md-8 control-label" for="accountNumber">
          Account Number (DDA)
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="accountNumber"
            id="accountNumber"
            [ngClass]="{
              'is-invalid':
                accountDetailsFormControls.accountNumber?.invalid &&
                (accountDetailsFormControls.accountNumber?.dirty ||
                  accountDetailsFormControls.accountNumber?.touched)
            }"
            formControlName="accountNumber"
          />
          <div
            *ngIf="
              accountDetailsFormControls.accountNumber?.invalid &&
              (accountDetailsFormControls.accountNumber?.dirty ||
                accountDetailsFormControls.accountNumber?.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="accountDetailsFormControls.accountNumber?.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="
                accountDetailsFormControls.accountNumber?.errors?.maxlength
              "
            >
              Value is too long. Please shorten it.
            </div>
            <div
              class="text-danger"
              *ngIf="accountDetailsFormControls.accountNumber?.errors?.pattern"
            >
              Only numbers allowed.
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div *ngIf="this.separateFees" formGroupName="otherAccountDetails">
      <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
        <label class="col-md-8 control-label" for="accountUsage">
          Account Usage
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                name="accountUsage2"
                id="accountUsage2"
                formControlName="accountUsage"
                [ngClass]="{
                  'is-invalid':
                    otherAccountDetailsFormControls.accountUsage.invalid &&
                    (otherAccountDetailsFormControls.accountUsage.dirty ||
                      otherAccountDetailsFormControls.accountUsage.touched)
                }"
                (change)="accountUsageChange($event)"
              >
                <option value="">--- Select Account Usage ---</option>
                <option
                  *ngFor="let ac of accountUsage | keyvalue"
                  [value]="ac.key"
                >
                  {{ ac.value }}
                </option>
              </select>
              <div
                *ngIf="
                  otherAccountDetailsFormControls.accountUsage.invalid &&
                  (otherAccountDetailsFormControls.accountUsage.dirty ||
                    otherAccountDetailsFormControls.accountUsage.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="
                    otherAccountDetailsFormControls.accountUsage.errors
                      ?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
        <label class="col-md-8 control-label" for="accountType">
          Account Type
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                name="accountType2"
                id="accountType2"
                formControlName="accountType"
                [ngClass]="{
                  'is-invalid':
                    otherAccountDetailsFormControls.accountType.invalid &&
                    (otherAccountDetailsFormControls.accountType.dirty ||
                      otherAccountDetailsFormControls.accountType.touched)
                }"
                (change)="resetDepositType($event)"
              >
                <option value="">--- Select Account Type ---</option>
                <option
                  *ngFor="let type of accountTypes | keyvalue"
                  [value]="type.key"
                >
                  {{ type.value }}
                </option>
              </select>
              <div
                *ngIf="
                  otherAccountDetailsFormControls.accountType.invalid &&
                  (otherAccountDetailsFormControls.accountType.dirty ||
                    otherAccountDetailsFormControls.accountType.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="
                    otherAccountDetailsFormControls.accountType.errors?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-group"
        *ngIf="
          otherAccountDetailsFormControls.accountType.value === 'C' &&
          otherAccountDetailsFormControls.accountUsage.value !==
            'FeeWithdrawals'
        "
        [ngClass]="{
          fieldIsRequired:
            otherAccountDetailsFormControls.accountType.value &&
            otherAccountDetailsFormControls.accountType.value === 'C'
        }"
      >
        <label class="col-md-8 control-label" for="checkingDepositType2">
          Checking Deposit Type
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                name="checkingDepositType2"
                id="checkingDepositType2"
                formControlName="checkingDepositType"
                [ngClass]="{
                  'is-invalid':
                    otherAccountDetailsFormControls.checkingDepositType
                      .invalid &&
                    (otherAccountDetailsFormControls.checkingDepositType
                      .dirty ||
                      otherAccountDetailsFormControls.checkingDepositType
                        .touched)
                }"
              >
                <option value="">--- Select Deposit Type ---</option>
                <option
                  *ngFor="let type of depositTypes | keyvalue"
                  [value]="type.key"
                >
                  {{ type.value }}
                </option>
              </select>
              <div
                *ngIf="
                  otherAccountDetailsFormControls.checkingDepositType.invalid &&
                  (otherAccountDetailsFormControls.checkingDepositType.dirty ||
                    otherAccountDetailsFormControls.checkingDepositType.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="
                    otherAccountDetailsFormControls.checkingDepositType.errors
                      ?.required
                  "
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
        <label class="col-md-8 control-label" for="routingNumber2">
          Routing Number (ABA)
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="routingNumber2"
            id="routingNumber2"
            [ngClass]="{
              'is-invalid':
                otherAccountDetailsFormControls.routingNumber.invalid &&
                (otherAccountDetailsFormControls.routingNumber.dirty ||
                  otherAccountDetailsFormControls.routingNumber.touched)
            }"
            formControlName="routingNumber"
          />
          <div
            *ngIf="
              otherAccountDetailsFormControls.routingNumber.invalid &&
              (otherAccountDetailsFormControls.routingNumber.dirty ||
                otherAccountDetailsFormControls.routingNumber.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                otherAccountDetailsFormControls.routingNumber.errors?.required
              "
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="
                otherAccountDetailsFormControls.routingNumber.errors?.pattern
              "
            >
              Please enter 9 numeric characters.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: true }">
        <label class="col-md-8 control-label" for="accountNumber2">
          Account Number (DDA)
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="accountNumber2"
            id="accountNumber2"
            [ngClass]="{
              'is-invalid':
                otherAccountDetailsFormControls.accountNumber.invalid &&
                (otherAccountDetailsFormControls.accountNumber.dirty ||
                  otherAccountDetailsFormControls.accountNumber.touched)
            }"
            formControlName="accountNumber"
          />
          <div
            *ngIf="
              otherAccountDetailsFormControls.accountNumber.invalid &&
              (otherAccountDetailsFormControls.accountNumber.dirty ||
                otherAccountDetailsFormControls.accountNumber.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                otherAccountDetailsFormControls.accountNumber.errors?.required
              "
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="
                otherAccountDetailsFormControls.accountNumber.errors?.maxlength
              "
            >
              Value is too long. Please shorten it.
            </div>
            <div
              class="text-danger"
              *ngIf="
                otherAccountDetailsFormControls.accountNumber.errors?.pattern
              "
            >
              Only numbers allowed.
            </div>
            <div
              class="text-danger"
              *ngIf="
                otherAccountDetailsFormControls.accountNumber.errors
                  ?.invalidAccountDetails
              "
            >
              Account number cannot be same.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <div
    class="text-danger"
    *ngIf="parentGroup.errors?.invalidAccountDetails"
  ></div>
</div>
